import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import ScrollMemory from 'react-router-scroll-memory';
import { QUEUE_NAMES } from '@bitComponents/utils/context';
import Stopper, { THEMES } from '@bitComponents/unifiedComponents/Stopper';
import { actions as contextActions } from './Reducers/context';
import CreateRouter from './createRouter';
import ErrorBoundary from './ErrorBoundary';

class Core extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextData: null,
    };
  }

  componentWillUnmount = () => {
    try {
      const { projectId } = this.props;
      window.nookInfoExchange.cleanObserver(
        QUEUE_NAMES.GLOBAL,
        `MainAppControllerListener-${projectId}-keepContextUpdated`,
      );
    } catch (err) {
      //
    }
  };

  componentDidMount = () => {
    const { projectId } = this.props;
    window.nookInfoExchange.registerAsObserver(
      QUEUE_NAMES.GLOBAL,
      `MainAppControllerListener-${projectId}-keepContextUpdated`,
      (context) => {
        this.props.setContextData(context);
      },
      false,
    );
    // Lógica testAB
    window.nookInfoExchange.registerAsObserver(
      QUEUE_NAMES.GLOBAL,
      `MainAppControllerListener-${projectId}`,
      (context) => {
        window.nookInfoExchange.cleanObserver(
          QUEUE_NAMES.GLOBAL,
          `MainAppControllerListener-${projectId}`,
        );
        this.setState({ contextData: context });
        // enviamos el evento aunque no haga nada
        window.nookInfoExchange.sendMessage('CUSTO_TEST_VERSION', {
          testDisable: true,
          testVersion: '',
          testName: '',
        });
      },
    );
  };

  render() {
    const {
      projectId,
      history,
      urlLibrary,
      modulesLibrary,
      defaultErrorScreen,
      inPageError,
    } = this.props;
    const { contextData } = this.state;

    if (!contextData) {
      // fake o algo timeout de error...
      return <div className="mainContent xux loading" />;
    }

    return (
      <Fragment>
        <div id="mainContent" className="mainContent xux">
          <ErrorBoundary
            history={history}
            projectId={projectId}
            defaultErrorScreen={defaultErrorScreen}
            contextData={contextData}
          >
            {inPageError && (
              <Stopper
                theme={THEMES.EMPTY}
                content={inPageError.errorType}
                contentProps={inPageError.errorInfo}
                projectId={projectId}
              />
            )}
            {!inPageError &&
              CreateRouter(urlLibrary, modulesLibrary, contextData, projectId)}
          </ErrorBoundary>
          <ScrollMemory />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  inPageError: state.errorCatcher.inPageError,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setContextData: (data) => dispatch(contextActions.setContextData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Core);
